import { categories } from '../data';
import SectionHeader from './SectionHeader';

const toneMap = {
  primary: {
    icon: 'bg-primary-100 text-primary-700',
    chip: 'bg-background-100 text-foreground-600 ring-1 ring-background-200 hover:bg-primary-100 hover:text-primary-800 hover:ring-primary-200',
    badge: 'bg-primary-100 text-primary-800',
    border: 'hover:border-primary-300',
  },
  accent: {
    icon: 'bg-accent-100 text-accent-700',
    chip: 'bg-background-100 text-foreground-600 ring-1 ring-background-200 hover:bg-accent-100 hover:text-accent-800 hover:ring-accent-200',
    badge: 'bg-accent-100 text-accent-800',
    border: 'hover:border-accent-300',
  },
  secondary: {
    icon: 'bg-secondary-100 text-secondary-800',
    chip: 'bg-background-100 text-foreground-600 ring-1 ring-background-200 hover:bg-secondary-100 hover:text-secondary-900 hover:ring-secondary-300',
    badge: 'bg-secondary-100 text-secondary-900',
    border: 'hover:border-secondary-300',
  },
};

export default function Categories() {
  return (
    <section id="category" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="Category Directory"
          title="吃瓜分类导航"
          desc="把海量话题按内容方向分门别类。选择分类即可看到该方向下沉淀的标签与最新收录，快速定位你感兴趣的吃瓜方向。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => {
            const t = toneMap[c.tone];
            return (
              <article
                id={`cat-${c.id}`}
                key={c.id}
                className={`flex scroll-mt-24 flex-col rounded-2xl border border-background-200/80 bg-background-50 p-5 transition ${t.border}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl ${t.icon}`}>
                    <i className={c.icon} aria-hidden="true"></i>
                  </span>
                  <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${t.badge}`}>{c.count}</span>
                </div>
                <div className="mt-4 flex items-baseline gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{c.name}</h3>
                  <span className="text-xs text-foreground-400">{c.en}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{c.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {c.tags.map((tag) => (
                    <a
                      key={tag}
                      href="#tags"
                      onClick={() => document.getElementById('tags')?.scrollIntoView({ behavior: 'smooth' })}
                      className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium transition ${t.chip}`}
                    >
                      #{tag}
                    </a>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}